import type { AgentTodoOperation } from './types';

/** How many todos this call touched — drives singular/plural headers only. */
export const todoLabelCount = (
  operation: AgentTodoOperation,
  inputCount: number
): number => {
  if (operation === 'get' || operation === 'set') return inputCount;
  if (inputCount > 0) return inputCount;
  return 1;
};
